
























import { Component, Vue } from 'vue-property-decorator';
import DownloadFileBackground from '../../Utilities/DownloadFileBackground.vue';
import { PROCESS_TYPE_ENUM } from '@/services/Enums';

@Component({
    components: {
        DownloadFileBackground
    }
})
export default class GeolocatorPage extends Vue {
    downloadUrl: string = "/api/net20/DownloadGeolocator"
    processDescription: string = "NET20 - Downloading Geolocator Report"
    processType: PROCESS_TYPE_ENUM = PROCESS_TYPE_ENUM.downloadFiles;



    async downloadGeolocatorExcelReport() {
        this.$bvModal.show('download-file-background');
    }
}
